import React, { useState, useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { allMetricsAtom, selectedMetricsAtom, updateAnchorAtom, metricOrderAtom } from '../atoms';
import { MAX_ANCHORED_COUNT } from '../utils';
import CustomizeDropdown from '@components/common/CustomizeDropdown';

const MetricDropMenu = ({
    selectedMetrics,
    anchoredMetrics,
    exceedTimeLimit,
    mandatoryDimensions,
}) => {
    const containerRef: any = React.useRef();
    const metricOrder: any = useAtomValue(metricOrderAtom);
    const [innerSelectedMetrics, setInnerSelectedMetrics] = useState([]);
    const allMetrics = useAtomValue(allMetricsAtom);
    const setAnchorMetrics = useSetAtom(updateAnchorAtom);
    const setSelectedMetrics = useSetAtom(selectedMetricsAtom);

    useEffect(() => {
        setInnerSelectedMetrics(selectedMetrics);
    }, [selectedMetrics, anchoredMetrics]);

    const applySelectedMetrics = (metrics) => {
        const orderedMetrics = metrics.sort((a: string, b: string) => {
            return metricOrder.indexOf(a) - metricOrder.indexOf(b);
        });
        setSelectedMetrics(orderedMetrics);
    };

    const applyAnchorMetrics = (metric) => {
        setAnchorMetrics(metric);
    };

    return (
        <div id="viewer-session-customize-dropdown" ref={containerRef}>
            <CustomizeDropdown
                maxAnchorCount={MAX_ANCHORED_COUNT}
                applyAnchorMetrics={applyAnchorMetrics}
                applySelectedMetrics={applySelectedMetrics}
                allMetrics={allMetrics}
                selectedMetrics={innerSelectedMetrics}
                anchoredMetrics={anchoredMetrics}
                disabled={exceedTimeLimit}
                containerRef={containerRef}
                mandatoryDimensions={mandatoryDimensions}
            />
        </div>
    );
};

MetricDropMenu.defaultProps = {
    selectedMetrics: [],
    anchoredMetrics: {},
    exceedTimeLimit: false,
};

export default MetricDropMenu;
